import React from 'react';
import logo from '../assets/img/LogoOficial.png';
import jwt_decode from 'jwt-decode';

const Print = ({order, ...props}) => {
    const token = sessionStorage.getItem('rtvcrespoToken');
    const decodedToken = jwt_decode(token);
    const user = decodedToken.user;

    const pad = (number) => {
        return (number < 10) ? '0' + number : number;
    }

    const getCurrentDate = () => {
        let date = new Date();
        let dateString = [pad(date.getDate()), pad(date.getMonth()+1), date.getFullYear()].join('/');
        return dateString;
    }

    const getCurrentTime = () => {
        let date = new Date();
        let timeString = [pad(date.getHours()), pad(date.getMinutes())].join(':');
        return timeString;
    }

    const calculateTaxBase = (total) => {
        let vat_percentage = 1.21;
        let taxBase = 0;
        taxBase = total / vat_percentage;
        taxBase = taxBase.toFixed(2);
        return taxBase;
    }

    const calculateTaxCuota = (total) => {
        let vat_percentage_quota = 1.21;
        let quota = 0;
        let taxBase = total / vat_percentage_quota;
        quota = total - taxBase;
        quota = quota.toFixed(2);
        return quota;
    }

    return(
        <div className="print-hidden-container">
            <div className="print-container" style={{fontSize:'12px', fontFamily: 'Lucida Console'}}>
                {/*LOGO*/}
                <div style={{textAlign:'center', marginBottom: '25px'}}>
                    <img src={logo} alt="logo" style={{maxWidth:'250px'}}/>
                </div>

                {/*ENCABEZADO*/}
                <div style={{textAlign: 'center', marginBottom: '30px'}}>
                    <div style={{marginBottom:'4px'}}>Dirección: {user.address}</div>
                    <div style={{marginBottom:'4px'}}>Teléfono: {user.phone}</div>
                    <div style={{marginBottom:'4px'}}>Factura Simplificada</div>
                    <div style={{marginBottom:'4px'}}>P.V.P I.V.A INCLUÍDO</div>
                    {order &&
                        <div style={{marginBottom:'4px'}}>
                            Ticket nº {order.ticketId}
                        </div>
                    }
                </div>

                {/*FECHA*/}
                <div style={{textAlign:'right', marginBottom: '20px'}}>
                    <div>
                        {getCurrentDate()}
                    </div>
                    <div>
                        {getCurrentTime()}
                    </div>
                </div>

                {/*LISTADO*/}
                <table style={{fontSize:'12px', marginBottom: '20px'}}>
                    <colgroup>
                        <col width='60%' />
                        <col width='10%' />
                        <col width='30%' />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th style={{textAlign: 'left'}}>
                                PRODUCTO
                            </th>
                            <th style={{textAlign: 'right'}}>
                                CANTIDAD
                            </th>
                            <th style={{textAlign: 'right'}}>
                                PRECIO
                            </th>
                        </tr>

                        {order && order.lines.map((line, index) =>
                            <tr style={{marginBottom: '2px'}} key={index}>
                                <td style={{textOverflow: 'ellipsis'}}>
                                    {line.title} {line.model}
                                </td>
                                <td style={{textAlign: 'right'}}>
                                    {line.quantity}
                                </td>
                                <td style={{textAlign: 'right'}}>
                                    {line.price} €
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {/*TOTAL*/}
                <div style={{fontSize:'18px', fontWeight: 'bold', marginBottom: '20px'}}>
                    <span>
                        TOTAL
                    </span>
                    {order && 
                        <span style={{float: 'right'}}>
                            {order.total ? order.total : order.total_amount} €
                        </span>
                    }
                </div>

                <table style={{textAlign: 'center', fontSize: '12px', margin: '0 auto'}}>
                    <colgroup>
                        <col width='33%' />
                        <col width='33%' />
                        <col width='33%' />
                    </colgroup>

                    <tbody>
                        <tr>
                            <td>
                                IVA
                            </td>

                            <td>
                                Base Imp.
                            </td>

                            <td>
                                Cuota
                            </td>
                        </tr>

                        <tr>
                            <td>
                                21 %
                            </td>

                            {order && 
                                <React.Fragment>
                                    <td>
                                        {calculateTaxBase(order.total ? order.total : order.total_amount)}
                                    </td>

                                    <td>
                                        {calculateTaxCuota(order.total ? order.total : order.total_amount)}
                                    </td>
                                </React.Fragment>
                            }
                        </tr>

                        <tr>
                            <td>
                                Total:
                            </td>

                            {order && 
                                <React.Fragment>
                                    <td>
                                        {calculateTaxBase(order.total ? order.total : order.total_amount)}
                                    </td>

                                    <td>
                                        {calculateTaxCuota(order.total ? order.total : order.total_amount)}
                                    </td>
                                </React.Fragment>
                            }
                        </tr>
                    </tbody>
                </table>

                {/*PIE*/}
                <div style={{marginTop: '20px'}}>
                    <div style={{textAlign: 'center', marginBottom: '10px'}}>
                        GRACIAS POR SU VISITA
                    </div>
                    <div style={{textAlign: 'justify'}}>
                        PARA CAMBIO O DEVOLUCIÓN ES IMPRESCINDIBLE PRESENTAR EL TICKET, ENVASE ORIGINAL Y PRODUCTO EN PERFECTO ESTADO, EN UN <span style={{fontWeight: 'bold'}}>PLAZO DE 15 DÍAS</span>.
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Print;


// WEBPACK FOOTER //
// ./src/components/Print.js